<template>
    <div class="position-relative d-flex flex-column h-100">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-chevron-left donation-back-icon"
            viewBox="0 0 16 16"
            @click="backStep"
        >
            <path
                fill-rule="evenodd"
                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
            />
        </svg>
        <div class="flex-grow-1">
            <h2 class="donation-title text-center mb-3">
                Personal Information
            </h2>
            <TextField
                v-model="firstName"
                name="firstName"
                input-type="2"
                classWrapper="mb-3"
                placeholder="First Name"
            />
            <TextField
                v-model="lastName"
                name="lastName"
                input-type="2"
                classWrapper="mb-3"
                placeholder="Last Name"
            />
            <TextField
                v-model="email"
                name="email"
                input-type="2"
                classWrapper="mb-3"
                placeholder="Email address"
            />
            <div class="row no-gutters mb-3">
                <div class="col-5 pr-1">
                    <SelectField
                        v-model="country"
                        name="country"
                        :options="country_codes"
                        input-type="2"
                        classWrapper="mb-3"
                    />
                </div>
                <div class="col-7 pl-1">
                    <TextField
                        v-model="phoneNumber"
                        name="phoneNumber"
                        input-type="2"
                        placeholder="Phone number"
                    />
                </div>
            </div>
            <CheckboxField
                v-model="isAnonymously"
                name="isAnonymously"
                label="Donate anonymously"
                input-type="2"
            />
            <CheckboxField
                v-model="isAnOrganization"
                name="isAnOrganization"
                label="Donate as an organization"
                input-type="2"
                classWrapper="mb-2"
                noMarginBottom
            />
            <TextField
                v-if="isAnOrganization"
                v-model="organizationName"
                name="organizationName"
                input-type="2"
                placeholder="Organization name"
            />
        </div>
        <button @click="submit"
                :disabled="!isValid"
                class="btn w-100 ok-btn mt-3">Continue</button>
    </div>
</template>

<script>
import TextField from '@/commons/FormElements/TextField.vue';
import SelectField from '@/commons/FormElements/SelectField.vue';
import CheckboxField from '@/commons/FormElements/CheckboxField.vue';
export default {
    name: 'PersonalInformation',
    components: {
        TextField,
        SelectField,
        CheckboxField,
    },
    props: {
        country_codes: {
            type: Array,
            default: () => [],
        },
        donationFormData: {
            type: Object,
            default: () => ({}),
        },
    },
    created() {
        this.firstName = this.donationFormData.firstName;
        this.lastName = this.donationFormData.lastName;
        this.email = this.donationFormData.email;
        this.phoneNumber = this.donationFormData.phoneNumber;
        this.country = this.donationFormData.country;
        this.isAnonymously = this.donationFormData.isAnonymously;
        this.isAnOrganization = this.donationFormData.isAnOrganization;
        this.organizationName = this.donationFormData.organizationName;
    },
    data() {
        return {
            firstName: '',
            lastName: '',
            email: '',
            phoneNumber: '',
            country: 'US',
            isAnonymously: false,
            isAnOrganization: false,
            organizationName: '',
        };
    },
    computed: {
        isValid() {
            return (
                this.firstName &&
                this.lastName &&
                this.email &&
                this.phoneNumber &&
                this.country && (this.isAnOrganization ? this.organizationName : true)
            );
        }
    },
    methods: {
        backStep() {
            this.$emit('changeStep', 2);
            this.$emit('updateData', {
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                phoneNumber: this.phoneNumber,
                country: this.country,
                isAnonymously: this.isAnonymously,
                isAnOrganization: this.isAnOrganization,
                organizationName: this.organizationName,
            });
        },
        submit() {
            this.$emit('changeStep', 4);
            this.$emit('updateData', {
                firstName: this.firstName,
                lastName: this.lastName,
                email: this.email,
                phoneNumber: this.phoneNumber,
                country: this.country,
                isAnonymously: this.isAnonymously,
                isAnOrganization: this.isAnOrganization,
                organizationName: this.organizationName,
            });
        },
    },
};
</script>
